import { Injectable, inject } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { UserActivity } from '../models';
import { Repository } from '../database/repository';

@Injectable({
  providedIn: 'root',
})
export class UserActivityRepository extends Repository<UserActivity, 'id', true> {

  constructor() {
    const db = inject(NgxIndexedDBService);

    super(db, 'userActivity', 'id');
  }

}
